import React from "react";
import Modal from "../ModalTemplate";
import Button from "../Button";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";

export default NiceModal.create(() => {
  const modal = useModal();
  const isUltraInsider = modal?.args?.ultraInsider;

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={`vuse-fragrance-2025-modal ${
        isUltraInsider ? "ultra-insider" : ""
      }`}
    >
      <div className="content-wrapper">
        <h2 className="title">BOP: Inhaltsstoffe</h2>
        <p className="head">Signs of You (50 ml)</p>
        <p className="text">
          <strong>INGREDIENTS: </strong>ALCOHOL, FRAGRANCE (PARFUM), TETRAMETHYL
          ACETYLOCTAHYDRONAPHTHALENES, WATER (AQUA), JUNIPERUS VIRGINIANA OIL,
          DIETHYLHEXYL SYRINGYLIDENEMALONATE, LIMONENE, PINENE, BENZYL ALCOHOL,
          POGOSTEMON CABLIN OIL, BETA-CARYOPHYLLENE, CAPRYLIC/CAPRIC
          TRIGLYCERIDE, COUMARIN, TERPINOLENE, HEXADECANOLACTONE, ISOEUGENYL
          ACETATE, ISOEUGENOL, ROSE KETONES, TERPINEOL, LINALOOL,
          ALPHA-TERPINEENE, EUGENOL
        </p>
        <p className="head">Cosmic Dust (15 ml)</p>
        <p className="text">
          <strong>INGREDIENTS: </strong>ALCOHOL, FRAGRANCE (PARFUM), TETRAMETHYL
          ACETYLOCTAHYDRONAPHTHALENES, WATER (AQUA), ACETYL CEDRENE, COUMARIN,
          LINALOOL, POGOSTEMON CABLIN OIL, ALPHA-TERPINOLENE,IONONE, VANILLIN,
          LINALYL ACETATE, DIETHYLHEXYL SYRINGYLIDENEMALONATE, BENZYL
          SALICYLATE, DIMETHYL PHENETHYL ACETATE, CEDRUS ATLANTICA OIL/EXTRACT,
          BENZYL ALCOHOL, GERANIOL, LIMONENE, CITRONELLOL, GERANYL ACETATE,
          CINNAMOMUM ZEYLANICUM BARK OIL, EUGENOL, CAPRYLIC/CAPRIC TRIGLYCERIDE,
          CINNAMYL ALCOHOL, BETA-CARYOPHYLLENE, TERPINOLENE, PELARGONIUM
          GRAVEOLENS FLOWER OIL, PINENE, BENZALDEHYDE, BENZYL BENZOATE,
          TERPINOLENE, ROSE KETONES, TRIMETHYLCYCLOPENTENYL METHYLISOPENTENOL,
          ANISE ALCOHOL, CAMPHOR, EUGENYL ACETATE, CINNAMAL, CITRAL
        </p>
        <p className="head">Morning Blade (15 ml)</p>
        <p className="text">
          <strong>INGREDIENTS: </strong>ALCOHOL, FRAGRANCE (PARFUM), WATER
          (AQUA), DIETHYLHEXYL SYRINGYLIDENEMALONATE, ALPHA-ISOMETHYL IONONE,
          VANILLIN, CAPRYLIC/CAPRIC TRIGLYCERIDE, PINENE, CITRAL, ROSE FLOWER
          OIL/EXTRACT, LIMONENE, CITRONELLOL, GERANIOL, ROSE KETONES,
          BETA-CARYOPHYLLENE, BENZYL BENZOATE, BENZYL ALCOHOL,
          TRIMETHYLCYCLOPENTENYL METHYLISOPENTENOL Vivid Aura (15ml)
        </p>
        <p className="head">Vivid Aura (15ml)</p>
        <p className="text">
          <strong>INGREDIENTS: </strong>ALCOHOL, FRAGRANCE (PARFUM), WATER
          (AQUA), TETRAMETHYL ACETYLOCTAHYDRONAPHTHALENES, LINALOOL, BENZYL
          SALICYLATE, HYDROXYCITRONELLAL, BENZYL ALCOHOL, LINALYL ACETATE,
          LIMONENE, VANILLIN, COUMARIN, DIETHYLHEXYL SYRINGYLIDENEMALONATE,
          CITRUS AURANTIUM PEEL OIL, CITRONELLOL, CITRUS LIMON PEEL OIL, PINENE,
          AMYL SALICYLATE, GERANIOL, TERPINEOL, CAPRYLIC/CAPRIC TRIGLYCERIDE,
          CARANNA EXTRACT, EUGENOL, BENZYL BENZOATE, ISOEUGENOL, ROSE KETONES,
          GERANYL ACETATE, CITRAL, ALPHA-TERPINEENE, BENZYL BENZOATE,
          BETA-CARYOPHYLLENE, TRIMETHYLCYCLOPENTENYL METHYLISOPENTENOL, CINNAMYL
          ALCOHOL, FARNEOSOL, CARVONE
        </p>

        <div className="buttons-wrapper">
          <Button
            btnClass="yellow"
            action={(e) => {
              modal.hide();
            }}
          >
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
});
